<script>
import Auth from '@/pages/layouts/auth.vue';
import Input from "@/pages/components/form/vertical/input.vue";
import Checkbox from "@/pages/components/form/horizontal/checkbox.vue";
import {Link, useForm} from "@inertiajs/vue3";

export default {
  components: {
    Link,
    Auth,
    Input,
    Checkbox
  },
  props: {
    canResetPassword: {
      type: Boolean,
      status: String,
    }
  },
  data() {
    return {
      form: useForm({
        username: '',
        password: '',
        remember: false,
      })
    }
  },
  methods: {
    submit() {
      this.form.post(route('login'), {
        onFinish: () => this.form.reset('password')
      })
    }
  }
}
</script>

<template>
  <Auth title="Inloggen">
    <form class="form-horizontal form-material" @submit.prevent="submit">
      <Input v-model="form.username" :form="form" name="username" required autofocus autocomplete="username" placeholder="Gebruikersnaam"/>

      <Input v-model="form.password" :form="form" type="password" name="password" required autocomplete="current-password" placeholder="Wachtwoord"/>

      <div class="d-flex align-items-center mb-3">
        <Checkbox v-model="form.remember" :form="form" name="remember" label="Blijf ingelogd" :value="true"/>

        <div class="ms-auto">
          <Link :href="route('password.request')" class="text-primary text-decoration-underline">Wachtwoord vergeten?</Link>
        </div>
      </div>

      <div class="form-group">
        <button :disabled="form.processing" class="btn w-100 btn-lg btn-primary btn-rounded text-white" type="submit">Log In</button>
      </div>
    </form>
  </Auth>
</template>